





















































































import Vue from "vue";
import DialogWrapper from "@/components/dialog/DialogWrapper.vue";
import { Element, UploadDokument } from "@/types";

/**
 * @Emits upload if upload is clicked
 */
export default Vue.extend({
  name: "UplaodDialog",
  components: { DialogWrapper },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    document: {
      type: Object as () => UploadDokument,
      required: true,
    },
    categories: {
      type: Array as () => Array<Element>,
      required: true,
    },
    kommunen: {
      type: Array as () => Array<Element>,
      required: false,
    },
    withDescription: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      open: this.value,
    };
  },
  watch: {
    value() {
      this.open = this.value;
    },
    open() {
      this.$emit("input", this.open);
    },
  },
  methods: {
    onUpload() {
      this.$emit("upload", this.document);
    },
    deleteFile(event: any) {
      event.preventDefault();
      this.document.file = {} as File;
    },
  },
});
